export default __webpack_public_path__ + "static/media/ROM EXAM PATTERN 2025 (CLASS - 8).37d36b15.pdf";